import React from 'react';

const SuccessStory = () => {
    return (
        <section id="success" className="section-padding-lg bg-motion-dark overflow-hidden relative">
            <div className="absolute inset-0 opacity-10">
                <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
                    <path stroke="currentColor" strokeWidth="0.5" d="M0 100 Q 50 50 100 100 M0 0 Q 50 50 100 0" fill="none">
                    </path>
                    <circle cx="20" cy="20" r="10" fill="currentColor"></circle>
                    <circle cx="80" cy="80" r="15" fill="currentColor"></circle>
                </svg>
            </div>

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
                    <div className="mb-16 lg:mb-0" data-aos="fade-right">
                        <h2 className="label-md mb-3">Client Success Story</h2>
                        <h3 className="heading-lg text-white mb-6">
                            The Remedy Mental Health
                        </h3>
                        <p className="paragraph-lg text-primary-dark mb-8 max-w-lg">
                            Chose Trustpoint as its billing partner in 2025 across 9 locations in MN, WI, and SD, averaging
                            6,000 claims per month.
                        </p>

                        <div className="grid grid-cols-2 gap-8">
                            <div>
                                <p className="text-xl font-regular text-white mb-1">90%</p>
                                <p className="paragraph-md text-primary-dark">Claims recovered in 60 days</p>
                            </div>
                            <div>
                                <p className="text-xl font-regular text-white mb-1">90%</p>
                                <p className="paragraph-md text-primary-dark">Submitted within 3 days (DOS)</p>
                            </div>
                            <div>
                                <p className="text-xl font-regular text-white mb-1">Daily</p>
                                <p className="paragraph-md text-primary-dark">Denial update on treatments</p>
                            </div>
                            <div>
                                <p className="text-xl font-regular text-white mb-1">Daily</p>
                                <p className="paragraph-md text-primary-dark">Patient statements on accrued balances</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-primary-light rounded-3xl p-8 sm:p-10 border border-gray-100 relative" data-aos="fade-left">
                        <blockquote className="relative">
                            <p className="paragraph-lg text-secondary mb-8 pt-6">
                                "In 90 days, Trustpoint has transformed my practice. They capture 90% of claims in just 60 days,
                                giving me total confidence in our financial health."
                            </p>
                            <footer className="flex items-center">
                                <div>
                                    <div className="flex gap-1 text-accent mb-2">
                                        <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor" /></svg>
                                        <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor" /></svg>
                                        <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor" /></svg>
                                        <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor" /></svg>
                                        <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor" /></svg>
                                    </div>
                                    <p className="paragraph-md text-secondary mb-0 font-medium">Dr. Danielle DeShano</p>
                                    <p className="paragraph-sm">The Remedy Mental Health</p>
                                </div>
                            </footer>
                        </blockquote>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default SuccessStory;
